import { CubeIcon } from '@fronton/icons-react';
import { DesignRegistrationPanelStructure } from 'common/components/design-registration-panel';

export const KITCHEN_PANEL_TEXT = 'Запишитесь на\u00A0бесплатное проектирование или сделайте проект в\u00A0онлайн-конструкторе';
export const KITCHEN_PANEL_TEXT_KZ = 'Запишитесь на\u00A0бесплатное проектирование';

export const KITCHEN_DESIGNER_HREF = '/3d-planirovshchiki/kuhni/';

export const KITCHEN_PANEL_STRUCTURE: DesignRegistrationPanelStructure = {
  panel: {
    content: {
      leftIcon: CubeIcon,
      iconColor: 'accent-primary',
      iconType: 'duotone',
      text: '',
    },
    actionBlock: [],
  },
  mobilePanel: {
    content: {
      icon: CubeIcon,
      iconColor: 'accent-primary',
      iconType: 'duotone',
      text: '',
    },
    mobileButton: {
      elementBlock: 'landingProektKuhni',
      openModal: true,
      label: 'Записаться на проектирование',
    },
    actionBlock: [],
  },
};
